import { PictogramIcon } from '@speedlo/ui'
import React from 'react'
import { Route } from 'react-router-dom'
import { Container } from 'reactstrap'
import styled from 'styled-components/macro'

import { FShopOpeningHoursFragment } from '../../graph/generated'
import { formatTime } from '../../helpers/formats'
import { RM } from '../../tools/ramda'
import { ShopStatusDisplay } from './ShopStatusDisplay'

type TProps = {
  branch: Maybe<FShopOpeningHoursFragment>
}

const StyledShopOpeningHours = styled(Container)`
  margin: 0.4rem 0 0 0.1rem;
  display: flex;

  & div.times,
  & div.status {
    padding-left: 2rem;
  }

  .icon {
    margin-left: -0.1rem;
    position: absolute;
  }
`

export const ShopOpeningHours: React.FC<TProps> = ({ branch }) => {
  if (!branch) {
    return null
  }
  const openingHours = branch.businessHours.filter(RM.propEq('closed', false))
  return (
    <StyledShopOpeningHours fluid={true}>
      <PictogramIcon icon="clock" size={1.5} className="icon" />
      {openingHours.length > 0 && (
        <div className="times">
          {openingHours.map((businessHour, idx) => (
            <div data-testid="openingHours" key={idx}>
              {`${formatTime(businessHour.openAt)} - ${formatTime(
                businessHour.closeAt,
              )}`}
            </div>
          ))}
        </div>
      )}
      <div className="status">
        {branch && (
          <Route
            path="/order"
            render={() => (
              <ShopStatusDisplay
                status={branch}
                deliveryTime={branch.defaultDeliveryTime}
                pickupTime={branch.defaultPickupTime}
              />
            )}
          />
        )}
      </div>
    </StyledShopOpeningHours>
  )
}
